export const VEHICLE_CATEGORIES = ["vehicle_car", "vehicle_motorcycle", "vehicle_bicycle"];
export const MATERIAL_CATEGORIES = [
  "jewelry", "clothing", "shoes", "bags_accessories",
  "furniture", "home",
];
export const STORAGE_CATEGORIES = ["electronics_smartphone", "electronics_tablet", "electronics_laptop", "electronics_console"];
export const SIZE_CATEGORIES = ["clothing", "shoes"];
export const PC_HARDWARE_CATEGORIES = ["electronics_laptop", "electronics_pc_components"];
export const STORAGE_OPTIONS = [32, 64, 128, 256, 512, 1024, 2048];
export const CONDITIONS = ["new", "like_new", "very_good", "good", "fair", "poor", "damaged", "for_parts"];
export const fmtStorage = (gb) => (gb >= 1024 ? `${gb / 1024} TB` : `${gb} GB`);

export const CATEGORY_RESET_FIELDS = {
  brand: "", brand_custom: "", model: "", model_custom: "",
  storage_gb: "", item_size: "",
  energy_class: "", repair_status: "", repair_details: "", seasonality: "",
  service_history: "", recent_maintenance: "", body_condition: "",
  interior_condition: "", electronics_ok: "", euro_class: "", fuel_type: "", battery_soh: "",
  engine_cc: "", power_kw: "", owners_count: "", recent_inspection: false,
  book_edition: "", is_signed: false, out_of_print: false, has_dust_jacket: false, has_annotations: false,
  pc_component_type: "", vram: "", cpu_socket: "", ram_storage_spec: "", gpu_usage: "", pc_build_specs: "",
};

export const initialFormState = (searchParams) => ({
  ...CATEGORY_RESET_FIELDS,
  category: searchParams.get("category") || "electronics_smartphone",
  brand: searchParams.get("brand") || "",
  model: searchParams.get("model") || "",
  purchase_price: "",
  original_retail_price: "",
  condition: "very_good",
  purchase_type: "new",
  owned_time: "12",
  owned_unit: "months",
  age_at_purchase_time: "",
  age_at_purchase_unit: "years",
  urgency: "balanced",
  usage_hours: "",
  kilometers: "",
  material: "",
  has_box: false,
  has_accessories: false,
  has_warranty: false,
  has_certificate: false,
  has_verifiable_serial: false,
  rarity: "",
  description: "",
});

export const computeFlags = (form, brands, models) => {
  const brandIsOther = form.brand === "__other__";
  const modelIsOther = form.model === "__other__";
  return {
    isVehicle: VEHICLE_CATEGORIES.includes(form.category),
    isMotorVehicle: ["vehicle_car", "vehicle_motorcycle"].includes(form.category),
    isAppliance: ["appliance_large", "appliance_small"].includes(form.category),
    isBook: form.category === "books",
    isPC: PC_HARDWARE_CATEGORIES.includes(form.category),
    isRepairable: form.category.startsWith("electronics_") || form.category.startsWith("appliance_") || form.category.startsWith("vehicle_"),
    hasUsageHours: form.category.startsWith("electronics_"),
    hasStorage: STORAGE_CATEGORIES.includes(form.category),
    hasSize: SIZE_CATEGORIES.includes(form.category),
    hasMaterial: MATERIAL_CATEGORIES.includes(form.category),
    hasBrands: brands.length > 0,
    hasModels: models.length > 0,
    brandIsOther,
    modelIsOther,
    resolvedBrand: brandIsOther ? form.brand_custom : form.brand,
    resolvedModel: modelIsOther ? form.model_custom : form.model,
  };
};
